module.exports = __webpack_public_path__ + "static/img/text_tit.f48248d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/display-img/show_new/text_tit.png
// module id = GB3H
// module chunks = 15